export default defineNuxtRouteMiddleware(({ matched }) => {
  if (matched.length === 0 && import.meta.server)
    throw createError({
      statusCode: 404,
      statusMessage: 'Page Not Found',
    })
})
